import styled from 'styled-components'
import { ColorProp, MeasurementProp } from './interface'

const palettes = [
  'blueGray',
  'gray',
  'success',
  'info',
  'warning',
  'danger',
  'green',
  'red',
  'purple',
  'white',
  'powder',
  'charcoal',
  'blue',
]

export const ProgressBar = styled.div<MeasurementProp>`
  position: relative;
  width: 100%;
  height: ${({ theme, size }) => (size ? theme.space[size] : '10px')};
  border-radius: ${({ theme }) => theme.space.md};
  border: 1px solid ${({ theme }) => theme.palette.gray100};
  overflow: hidden;
  background: ${({ theme }) => theme.palette.blueGray10};
`

export const Filler = styled.div<ColorProp>`
  background: ${({ theme, color = 'brandPrimary' }) =>
    palettes.some((palette) => color.includes(palette)) ? theme.palette[color] : theme.colors[color]};
  height: 100%;
  border-radius: inherit;
  transition: width 0.2s ease-in;
`
